/**
 * Labstep
 *
 * @module components/Filter/Metadata/Active
 * @desc Active node component for log author_id filter
 */

import type { FilterLogCreatedByActiveProps } from 'labstep-web/components/Filter/LogCreatedBy/Active/types';
import { ICONS } from 'labstep-web/constants/icons';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import type React from 'react';

export const FilterLogCreatedByActive: React.FC<
  FilterLogCreatedByActiveProps
> = ({ clearParams, searchParams }) => {
  if (!('author_id' in searchParams)) {
    return null;
  }

  return (
    <RemoveLabel
      name="Organization Member"
      icon={ICONS.user.primary}
      onRemoveClick={
        clearParams && ((): void => clearParams(['author_id']))
      }
    />
  );
};
